document.addEventListener("DOMContentLoaded", function () {
  var inputElement = document.getElementById("desktopSearch");
  words = ["Search for products...", "Davidoff Cool water Men/Women...", "Armaf Club de nuit intense for man/woman..."]
  var currentIndex = 0;

  function typeText() {
    var currentWord = words[currentIndex];
    var currentPlaceholder = inputElement.placeholder;
    if (currentPlaceholder.length < currentWord.length) {
      inputElement.placeholder = currentWord.substring(0, currentPlaceholder.length + 1);
      setTimeout(typeText, 100); // Adjust the typing speed here
    } else {
      setTimeout(deleteText, 1000); // Wait for 1 second before deleting
    }
  }

  function deleteText() {
    var currentPlaceholder = inputElement.placeholder;
    if (currentPlaceholder.length > 0) {
      inputElement.placeholder = currentPlaceholder.substring(0, currentPlaceholder.length - 1);
      setTimeout(deleteText, 50); // Adjust the deleting speed here
    } else {
      currentIndex = (currentIndex + 1) % words.length; // Move to the next word
      setTimeout(typeText, 500); // Wait for 0.5 seconds before typing the next word
    }
  }

  setTimeout(typeText, 500); // Wait for 0.5 seconds before starting
});

document.addEventListener("DOMContentLoaded", function () {
  var inputElement = document.getElementById("mobileSearch");
  words = ["Search for products...", "Davidoff Cool water Men/Women...", "Armaf Club de nuit intense for man/woman..."]
  var currentIndex = 0;

  function typeText() {
    var currentWord = words[currentIndex];
    var currentPlaceholder = inputElement.placeholder;
    if (currentPlaceholder.length < currentWord.length) {
      inputElement.placeholder = currentWord.substring(0, currentPlaceholder.length + 1);
      setTimeout(typeText, 100); // Adjust the typing speed here
    } else {
      setTimeout(deleteText, 1000); // Wait for 1 second before deleting
    }
  }

  function deleteText() {
    var currentPlaceholder = inputElement.placeholder;
    if (currentPlaceholder.length > 0) {
      inputElement.placeholder = currentPlaceholder.substring(0, currentPlaceholder.length - 1);
      setTimeout(deleteText, 50); // Adjust the deleting speed here
    } else {
      currentIndex = (currentIndex + 1) % words.length; // Move to the next word
      setTimeout(typeText, 500); // Wait for 0.5 seconds before typing the next word
    }
  }

  setTimeout(typeText, 500); // Wait for 0.5 seconds before starting
});
$(document).ready(function () {
  function updateHeaderCart() {
        var totalPrice = 0;
        $('.actions .checkout-cart').each(function () {
            $('.checkout-cart').addClass('d-none');
        });
        $('.cartTotal').text(totalPrice.toLocaleString('en-IN'));
    }
  updateHeaderCart();
    setInterval(updateHeaderCart, 100);
});